import axios from 'axios';
import { useFormik } from 'formik';
import swal from 'sweetalert';
import { loginSchema } from './login.schema';

export const showGeneralError = (errorMessage) =>
  swal({
    title: errorMessage ? undefined : 'Ups...',
    text: errorMessage || 'Ha ocurrido un error',
    icon: 'error',
    buttons: [false, 'OK']
  });

const handleApiError = (err) => {
  const httpError = err.response;
  if (httpError) {
    const { errors } = httpError.data;
    if (errors && Object.keys(errors).length > 0) {
      const errorMesages = [];
      Object.keys(errors).forEach((key) => {
        errorMesages.push(errors[key][0]);
      });
      showGeneralError(errorMesages.join('\n'));
    } else {
      console.log(httpError);
      showGeneralError();
    }
  } else {
    console.log(httpError);
    showGeneralError();
  }
};

export const useLoginFormik = () => {
  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      password: ''
    },
    validationSchema: loginSchema,
    onSubmit: (values, formikHelpers) => {
      const { setSubmitting } = formikHelpers;
      const { email, password } = values;

      const data = {
        email,
        password
      };

      setSubmitting(true);

      axios
        .post(`${process.env.REACT_APP_BASE_URL_API}/v1/clubs/auth/login`, data)
        .then((res) => {
          const urlPanel = process.env.REACT_APP_BASE_URL_PANEL.replace(
            '{subdomain}',
            res.data.subdomain
          );

          window.location.href = `${urlPanel}/login?token=${res.data.access_token}`;
        })
        .catch((err) => {
          handleApiError(err);
          setSubmitting(false);
        });

      return false;
    }
  });

  return formik;
};
